import Select from 'react-select'; // eslint-disable-line
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React from 'react';
import i18n from '../../i18n';
import ChurchStreaming from '../../assets/images/churchstreaming.png';
import AmplifyStreaming from '../../assets/images/AmplifyStreaming.png';
import MyParishSoftStreaming from '../../assets/images/myParishSoft-logo.png';
import GreenCheck from '../../components/svg/GreenCheck';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import ManagedInput from '../../components/forms/ManagedInput';
import _actions from '../../actions';
import constants from '../../constants';
import appStateProvider from "../../utilities/appStateProvider";
import { ENVIRONMENT } from '../../utilities/constants';

class LiveStreamingIntegration extends React.Component {
    timer = null;

    constructor(props) {
        super(props);
        this.updateModuleFromEvent = this.updateModuleFromEvent.bind(this);
        this.setStateFromEvent = this.setStateFromEvent.bind(this);
        this.updateModuleForFieldWithValue = this.updateModuleForFieldWithValue.bind(this);
        this.updateDelayFromSelect = this.updateDelayFromSelect.bind(this);
        this.updateNullSubjectAndMessage = this.updateNullSubjectAndMessage.bind(this);
        this.state = {
            value: '',
            selectedChurchName: '',
            error: '',
            imageSrc: AmplifyStreaming,
            imgHeight: '64px'
        };
    }
    componentDidMount() {
        let imageSrc = '';
        let imgHeight = '';
        const appState = appStateProvider();
        const activeEnvironment = appState.getActiveEnvironment();

        if(activeEnvironment === ENVIRONMENT.AMPLIFY) {
            imageSrc = AmplifyStreaming;
            imgHeight = '64px';
        } else if(activeEnvironment === ENVIRONMENT.MY_PARISH_SOFT) {
            imageSrc = MyParishSoftStreaming;
            imgHeight = '64px'
        } else {
            imageSrc = ChurchStreaming
            imgHeight = '32px'
        }
        this.setState({imageSrc, imgHeight});
        
    }
    componentDidUpdate(prevProps) {
        if (!this.props.modules?.allInProgress && !this.state?.selectedChurchName) {
            const streamingModuleTypeId = constants.ModuleType.find((m) => m.Name === 'LiveStreaming')?.Id;
            
            const liveStreamingModule = this.props.modules.data.find((module) =>
                    module.moduleType === streamingModuleTypeId
            );
        
            if (liveStreamingModule?.streamingName) {
                this.setState({ selectedChurchName: liveStreamingModule.streamingName });
            }
        }

        if (prevProps.integrations.inProgress && !this.props.integrations.inProgress) {
            if (this.props.integrations.cserror && this.props.integrations.cserror.length > 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ error: 'An error occurred. Please try again or contact support.' });
            } else {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    options: this.props.integrations.results?.map((x) => {
                        return {
                            value: x.id,
                            label: x.name,
                        };
                    }),
                });
            }
        }
    }

    setStateFromEvent(e, stateKey) {
        const stateObj = {};
        stateObj[stateKey] = e.target.value;
        this.setState(stateObj);
    }

    updateSearch = (input) => {
        clearTimeout(this.timer);
        this.setState({ value: input });
        this.timer = setTimeout(this.triggerChange, 1000);
    }

    triggerChange = () => {
        const { value } = this.state;
        this.searchUser(value);
    }

    selectedChurch = (input) => {
        this.setState({ selectedChurchName: input.label });
        this.updateModuleForFieldWithValue('streamingId', input.value);
        this.updateModuleForFieldWithValue('streamingName', input.label);
        this.updateModuleForFieldWithValue('enabled', true);
    }

    disconnectStream = () => {
        this.setState({ selectedChurchName: '' });
        this.updateModuleForFieldWithValue('streamingId', null);
        this.updateModuleForFieldWithValue('streamingName', null);
    }

    updateNullSubjectAndMessage() {
        const fields = [{ parameterName: 'pushNotifyOnStream', parameterValue: true }];

        if (!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushSubject || this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushSubject.trim() === '') {
            fields.push({
                parameterName: 'pushSubject',
                parameterValue: this.props.versions.select.churchName + i18n.t('integrations.live-streaming.notification-subject-default'),
            });
            this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushSubject = this.props.versions.select.churchName + i18n.t('integrations.live-streaming.notification-subject-default');
        }

        if (!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushMessage || this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushMessage.trim() === '') {
            fields.push({
                parameterName: 'pushMessage',
                parameterValue: i18n.t('integrations.live-streaming.notification-body-default'),
            });
            this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushMessage = i18n.t('integrations.live-streaming.notification-body-default');
        }
        this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushNotifyOnStream = true;
        this.updateModuleFieldsWithValues(fields);
    }

    updateModuleFieldsWithValues(fields) {
        this.props.actions.updateModule(
            this.props.versions.select.projectId,
            constants.ModuleType.find((c) => { return c.Name === 'LiveStreaming'; }).Id,
            fields,
        );
    }

    updateModuleFromEvent(evt) {
        const fieldName = evt.target.name;
        let changedValue = evt.target.value;
        if (evt.target.type === 'checkbox') {
            changedValue = evt.target.checked;
        }

        if (fieldName === 'pushNotifyOnStream' && changedValue === true) this.updateNullSubjectAndMessage();
        else if (changedValue !== this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0][fieldName]) this.updateModuleForFieldWithValue(fieldName, changedValue);
    }

    updateModuleForFieldWithValue(field, val) {
        const moduleRet = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0];
        moduleRet[field] = val;
        this.props.actions.updateModuleParameter(
            this.props.versions.select.projectId,
            constants.ModuleType.find((c) => { return c.Name === 'LiveStreaming'; }).Id,
            field,
            val,
        );
    }

    updateDelayFromSelect(val) {
        this.updateModuleForFieldWithValue('pushDelay', parseInt(val.value, 10));
    }

    searchUser(term) {
        this.props.actions.searchStreams(term);
    }

    render() {
        if (this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0]) {
            const addChurchForm = (
                <div className="inactive-church general-section module-display-settings-list">
                    <h2 className="section-name">{i18n.t('integrations.live-streaming.inactive-header')}</h2>
                    <p>{i18n.t('integrations.live-streaming.inactive-subtitle')}</p>

                    <div className="module-display-setting" data-qa="church-streaming-addChurchForm">
                        <HorizontalFormContainer
                            inputClass="module-display-setting__setting"
                            title={i18n.t('integrations.live-streaming.search')}
                        >
                            <div className="help">{this.state.error}</div>
                        </HorizontalFormContainer>

                        <Select
                            name="form-field-name"
                            value="one"
                            onInputChange={(e) => {
                                this.updateSearch(e);
                            }}
                            className="form-selector"
                            classNamePrefix="form-selector"
                            options={this.state.options}
                            filterOption={() => {
                                return true;
                            }}
                            onChange={(e) => {
                                this.selectedChurch(e);
                            }}
                            autosize={false}
                            placeholder={i18n.t('integrations.live-streaming.placeholder')}
                        />
                    </div>
                </div>
            );
            const delayOpts = [
                { value: '0', label: i18n.t('integrations.live-streaming.time-opts.0') },
                {
                    value: '5',
                    label: i18n.t('integrations.live-streaming.time-opts.5') + i18n.t('integrations.live-streaming.time-opts.suffix'),
                },
                {
                    value: '10',
                    label: i18n.t('integrations.live-streaming.time-opts.10') + i18n.t('integrations.live-streaming.time-opts.suffix'),
                },
                {
                    value: '15',
                    label: i18n.t('integrations.live-streaming.time-opts.15') + i18n.t('integrations.live-streaming.time-opts.suffix'),
                },
            ];

            const pushOptions = (
                <div className="notification-options" id="notification-options">

                    <div className="module-display-setting notification-delay">
                        <HorizontalFormContainer
                            inputClass="module-display-setting__setting"
                            title={i18n.t('integrations.live-streaming.notification-delay')}
                        >
                            <div id="notification-delay" className="form-control">
                                <Select
                                    id="delayOptions"
                                    options={delayOpts}
                                    name="pushDelay"
                                    className="form-selector"
                                    classNamePrefix="form-selector"
                                    value={this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushDelay?.toString() ? delayOpts.find((f) => { return f.value === this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushDelay.toString(); }) : delayOpts.find((f) => { return f.value === '5'; })}
                                    onChange={this.updateDelayFromSelect}
                                    clearable={false}
                                    searchable={false}
                                    disabled={!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled}
                                />
                            </div>
                        </HorizontalFormContainer>

                    </div>
                    <div className="module-display-setting notification-subject">
                        <HorizontalFormContainer
                            inputClass="module-display-setting__setting"
                            title={i18n.t('integrations.live-streaming.notification-subject')}
                            tooltipName="notification-subject-tooltip"
                            tooltipText={i18n.t('integrations.live-streaming.notification-subject-tooltip')}
                        />
                        <div id="notification-subject" className="form-control">
                            <ManagedInput
                                type="text"
                                placeholder={i18n.t('integrations.live-streaming.notification-subject-placeholder')}
                                name="pushSubject"
                                value={this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushSubject}
                                maxLength={100}
                                onBlur={this.updateModuleFromEvent}
                                onReturnDown={this.updateModuleFromEvent}
                                autoFocus={false}
                                disabled={!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled}
                            />
                        </div>
                    </div>
                    <div className="module-display-setting notification-message">
                        <HorizontalFormContainer
                            inputClass="module-display-setting__setting"
                            title={i18n.t('integrations.live-streaming.notification-body')}
                            tooltipName="notification-message-tooltip"
                            tooltipText={i18n.t('integrations.live-streaming.notification-message-tooltip')}
                        />
                        <div id="notification-message" className="form-control">
                            <ManagedInput
                                type="text"
                                placeholder={i18n.t('integrations.live-streaming.notification-body-placeholder')}
                                name="pushMessage"
                                value={this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushMessage}
                                maxLength={240}
                                onBlur={this.updateModuleFromEvent}
                                onReturnDown={this.updateModuleFromEvent}
                                autoFocus={false}
                                disabled={!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled}
                            />
                        </div>
                    </div>
                </div>
            );
            const churchSelected = (
                <div id="stream-connected" className="stream-connected">
                    <div className="stream-info show">
                        <GreenCheck />
                        <p><span>{this.state.selectedChurchName}</span></p>

                        {/* eslint-disable-next-line */}
                        <a
                            id="disconnect-stream"
                            className="btn btn-sq btn-outline btn-sm"
                            onClick={this.disconnectStream}
                        >
                            {i18n.t('disconnect')}
                        </a>
                    </div>

                    <div className="general-section module-display-settings-list">

                        <h2 className="section-name">{i18n.t('integrations.live-streaming.active-header')}</h2>
                        <p>{i18n.t('integrations.live-streaming.active-subtitle')}</p>
                        <HorizontalFormContainer
                            inputClass="module-display-setting__toggle"
                            title={i18n.t('integrations.live-streaming.toggle-label')}
                        >

                            <OnOffSwitch
                                id="enabled-tab"
                                buttonClass="toggle checkbox md-checkbox"
                                isToggleOn={this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled}
                                name="enabled"
                                onChange={this.updateModuleFromEvent}
                                dataQA="liveStreaming-enabled"
                            />

                        </HorizontalFormContainer>
                        <div
                            className={`${this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled ? '' : 'disabled-section'}`}
                        >
                            <HorizontalFormContainer
                                inputClass="module-display-setting__toggle"
                                title={i18n.t('integrations.live-streaming.notification-toggle')}
                                tooltipName="notification-toggle-tooltip"
                                tooltipText={i18n.t('integrations.live-streaming.notification-toggle-tooltip')}
                            >

                                <OnOffSwitch
                                    id="push-notify-tab"
                                    buttonClass="toggle checkbox md-checkbox"
                                    isToggleOn={this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushNotifyOnStream}
                                    name="pushNotifyOnStream"
                                    onChange={this.updateModuleFromEvent}
                                    disabled={!this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].enabled}
                                    dataQA="liveStreaming-pushnotifications"
                                />

                            </HorizontalFormContainer>
                            {this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'LiveStreaming'; }).Id; })[0].pushNotifyOnStream ? pushOptions : ''}
                            <p
                                className="subtext"
                            >
                                {i18n.t('integrations.live-streaming.helper-text')}
                            </p>
                        </div>
                    </div>
                </div>
            );

            return !this.props.modules.allInProgress ? (

                <div id="live-streaming-form" className="form-wrapper">
                    <img height={this.state.imgHeight} alt="ChurchStreaming.TV" src={this.state.imageSrc} />
                    {this.state.selectedChurchName.length < 1 ? addChurchForm : churchSelected}
                </div>
            ) : '';
        }

        return '';
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamingIntegration);
